// Variant A: Sidebar Tree (Asana-style nested tree in left panel)
// The original v2 shape: expand Company → Build → Task → Subtask in a persistent
// left sidebar, detail pane renders whatever is selected.
import { Sidebar } from '../components/Sidebar';
import { DetailPane } from '../components/DetailPane';

export function VariantSidebar() {
  return (
    <div className="h-full flex overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex overflow-hidden">
        <DetailPane />
      </div>
    </div>
  );
}
